module.exports = __webpack_public_path__ + "static/img/1.c813581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/1.png
// module id = 5FsZ
// module chunks = 156